<basetile-renderer #mdFreedataExampleTileRenderer class="not-clickable">
  <div target="title">
    <wiz-label [wizLabel]="data.code" [wizTextBehavior]="'truncate'"></wiz-label>
  </div>
  <div target="actionButtons">
    <wiz-hgroup width="100%" height="100%" [verticalAlign]="'center'" gap="10" [horizontalAlign]="'end'">
      <wiz-icon [wizTooltip]="'$.common.discover.$'" >see</wiz-icon>
      <wiz-icon [wizTooltip]="'$.common.clone.$'" >duplicate</wiz-icon>
    </wiz-hgroup>
  </div>
  <div target="body">
    <wiz-vgroup width="100%" height="100%">
      <wiz-label #lbName [wizLabel]="data.trsLabel" height="100%"></wiz-label>
    </wiz-vgroup>
  </div>
</basetile-renderer>
